import * as wjcGrid from "@grapecity/wijmo.grid"
import { 全部所車番検索Enabled } from "../../constant/featureFlags"
import * as wjcGridPdf from "@grapecity/wijmo.grid.pdf"
import * as wjcGridXlsx from "@grapecity/wijmo.grid.xlsx"
import * as wjcInput from "@grapecity/wijmo.input"
import dayjs from "dayjs"
import Decimal from "decimal.js"
import CONSTANT from "../../constant"
import constants from "../../constant/constant"
import {
  e消費税計算区分,
  e計上基準日区分,
  e請求車輌区分,
  T消費税計算区分,
  T計上基準日区分,
} from "../../constant/enum/master"
import {
  e工程区分,
  e請求支払処理状態区分,
  e請求支払区分,
  e請求支払確認区分,
  e配車状態区分,
} from "../../constant/enum/zyutuHaisya"
import { TVacationGetRes } from "../../service/attendance/vacation/TVacation"
import { TZyomuinListItem } from "../../service/driver/TZyomuin"
import ZyomuinService from "../../service/driver/zyomuinService"
import { T品名マスタ } from "../../service/master/hinmei/THinmei"
import NinusiSeikyuService from "../../service/master/ninusiseikyu/ninusiSeikyuService"
import SiharaisakiService from "../../service/master/siharaisaki/siharaisakiService"
import { TTumiorosisakiListGetRes } from "../../service/master/tumiorosisaki/TTumiorosisaki"
import { T傭車マスタ } from "../../service/master/yosya/TYosya"
import { TZyutyuHaisyaListGetRes } from "../../service/order/zyutyuHaisya/TZyutyuHaisya"
import { TZyutyuHaisyaPatternListGetRes } from "../../service/order/zyutyuHaisyaPattern/TZyutyuHaisyaPattern"
import { TKaikonZyutyuHaisyaListGetRes } from "../../service/orderContainer/kaikonZyutyuHaisya/TKaikonZyutyuHaisya"
import {
  TTenkenSeibihiListGetRes,
  TTenkenSeibiListGetRes,
} from "../../service/truck/tenken/TTenken"
import { TSyaryoModalList } from "../../service/truck/TSyaryo"
import {
  get傭車itemsSourceFunctionByApi,
  get車輌itemsSourceFunctionByApi,
} from "./autoCompleteUtil"

export type grid用プロパティ = {
  row_id: symbol
  isSelected?: boolean
  請求合計?: number
  支払合計?: number
  車輌最大積載量?: number
  bl受領書確認フラグ?: boolean
  高速料IDList?: number[]
}

export type T手入力チェック = {
  is積地手編集?: boolean
  is卸地手編集?: boolean
  is品名手編集?: boolean
  is乗務員売上手編集?: boolean
}

/**
 * 受注配車IDリストを取得し、それに合わせて並べ替えたリストを返却する
 * @param 受注配車IDList
 * @param 受注配車List
 * @returns 受注配車List
 */
export const sortBy受注配車ID = <T extends { 受注配車ID: number }>(
  受注配車IDList: number[],
  受注配車List: T[],
  returnList?: T[]
) => {
  let list: T[] = returnList ?? []

  受注配車IDList.forEach((受注配車ID) => {
    const 受注配車 = 受注配車List.find((e) => e.受注配車ID === 受注配車ID)
    if (受注配車 && !list.find((e) => e.受注配車ID === 受注配車ID)) {
      list.push(受注配車)
    }
  })
  // もしリストに載っていない受注配車がいた場合、返却リストの末尾にそのままの順番で入れていく
  受注配車List.forEach((受注配車) => {
    if (!list.find((e) => e.受注配車ID === 受注配車.受注配車ID)) {
      list.push(受注配車)
    }
  })

  return list
}

/**
 * 選択された受注配車パターンを受注配車の情報に変換する
 * @param パターン
 * @param castedData
 */
export const setPattern = async <
  TCastedItem extends TZyutyuHaisyaListGetRes & T手入力チェック
>(
  パターン: TZyutyuHaisyaPatternListGetRes,
  castedData: TCastedItem,
  set車輌情報: boolean = true
) => {
  castedData.荷主ID = パターン.荷主ID
  castedData.受注配車パターンコード = パターン.受注配車パターンコード
  castedData.荷主コード = パターン.荷主コード ?? ""
  // 名称は略称を使用する
  castedData.荷主名 = パターン.荷主略称1
  castedData.荷主請求ID = パターン.荷主請求ID
  castedData.表紙分割コード = パターン.表紙分割コード
  castedData.品代端数計算区分コード = パターン.品代端数計算区分コード
  castedData.品代端数計算区分ソート番号 = パターン.品代端数計算区分ソート番号
  castedData.品代端数計算区分名称1 = パターン.品代端数計算区分名称1
  castedData.表紙名 = パターン.表紙名
  castedData.コンテナサイズ = パターン.コンテナサイズ
  castedData.コンテナ軸 = パターン.コンテナ軸
  castedData.積地数 = パターン.積地数
  castedData.卸地数 = パターン.卸地数
  castedData.品数 = パターン.品数
  castedData.繰返運行数 = パターン.繰返運行数
  castedData.配送順 = パターン.配送順
  castedData.輸送備考 = パターン.輸送備考
  castedData.コース編集 = パターン.コース編集
  castedData.積地積卸先ID = パターン.積地積卸先ID
  castedData.積地積卸先コード = パターン.積地積卸先コード
  castedData.積地社名 = パターン.積地社名
  castedData.積地都道府県 = パターン.積地都道府県
  castedData.積地市区町村 = パターン.積地市区町村
  castedData.最大積載量 = パターン.最大積載量
  castedData.卸地積卸先ID = パターン.卸地積卸先ID
  castedData.卸地積卸先コード = パターン.卸地積卸先コード
  castedData.卸地社名 = パターン.卸地社名
  castedData.卸地都道府県 = パターン.卸地都道府県
  castedData.卸地市区町村 = パターン.卸地市区町村
  castedData.品コード =
    パターン.品コード != null
      ? パターン.品コード
      : パターン.品名 != null
      ? CONSTANT.自由入力品コード
      : undefined
  castedData.品名 = パターン.品名
  castedData.積載品数量 = パターン.積載品数量
  castedData.単位区分コード = パターン.単位区分コード
  castedData.単価 = パターン.単価
  castedData.荷主品名ID = パターン.荷主品名ID

  castedData.受注部所コード = パターン.受注部所コード
  castedData.受注部所名 = パターン.受注部所名
  castedData.運行部所コード = パターン.運行部所コード
  castedData.運行部所名 = パターン.運行部所名
  castedData.付替区分コード = パターン.付替区分コード
  castedData.付替区分名称1 = パターン.付替区分名称1
  if (set車輌情報) {
    castedData.支払先ID = パターン.支払先ID

    //支払先IDが存在した場合IDよりコードなどを取得
    if (パターン.支払先ID) {
      const 傭車会社 = await new SiharaisakiService().get(パターン.支払先ID)
      castedData.支払先コード = 傭車会社.data?.支払先コード
      castedData.傭車会社名 = 傭車会社.data.支払先名
    }

    castedData.車輌ID = パターン.車輌ID
    castedData.車番 = パターン.車番
    castedData.車種区分コード = パターン.車種区分コード
    castedData.車種区分名称1 = パターン.車種区分名称1
    castedData.最大積載量 = パターン.最大積載量
    castedData.トレーラ車輌ID = パターン.トレーラ車輌ID
    castedData.トレーラ車番 = パターン.トレーラ車番
    castedData.トレーラ車種区分コード = パターン.トレーラ車種区分コード
    castedData.トレーラ車種区分名称1 = パターン.トレーラ車種区分名称1
    castedData.トレーラ車種最大積載量 = パターン.トレーラ車種最大積載量
    castedData.乗務員ID = パターン.乗務員ID
    castedData.乗務員コード = パターン.乗務員コード
    castedData.乗務員名 = パターン.乗務員名
    castedData.同乗者乗務員ID = パターン.同乗者乗務員ID
    castedData.同乗者コード = パターン.同乗者コード
    castedData.同乗者名 = パターン.同乗者乗務員名
  }
  castedData.乗務員売上額 = パターン.乗務員売上額
  castedData.乗務員付帯料 = パターン.乗務員付帯料
  castedData.付帯高速料 = パターン.付帯高速料

  castedData.同乗者売上額 = パターン.同乗者売上額
  castedData.稼働手当車種掛率区分コード = パターン.稼働手当車種掛率区分コード
  castedData.食事手当 = パターン.食事手当
  castedData.稼働手当 = パターン.稼働手当
  castedData.特別手当 = パターン.特別手当
  castedData.その他手当 = パターン.その他手当
  castedData.荷主請求内訳ID = パターン.荷主請求内訳ID
  // 請求内訳コードはトン数補償の判定条件（請求運送料計算）に使用するため必ずコピーする
  castedData.請求内訳コード = パターン.請求内訳コード
  castedData.請求車輌区分コード = パターン.請求車輌区分コード
  castedData.請求車輌区分名称1 = パターン.請求車輌区分名称1
  castedData.請求区分コード = パターン.請求区分コード
  castedData.請求区分名称1 = パターン.請求区分名称1
  castedData.請求運送料課税区分コード = パターン.請求運送料課税区分コード
  castedData.請求運送料課税区分名称1 = パターン.請求運送料課税区分名称1
  castedData.請求運送料 = パターン.請求運送料
  castedData.請求付帯料課税区分コード = パターン.請求付帯料課税区分コード
  castedData.請求付帯料課税区分名称1 = パターン.請求付帯料課税区分名称1
  castedData.請求付帯料 = パターン.請求付帯料

  castedData.is乗務員売上手編集 = パターン?.乗務員売上手入力フラグ === 1
  // 高速料税込区分は最新の荷主請求IDより取得し登録する
  if (パターン.荷主請求ID != null) {
    try {
      const 荷主請求Res = await new NinusiSeikyuService().get(
        パターン.荷主請求ID
      )
      if (荷主請求Res && 荷主請求Res.data) {
        castedData.請求高速料税込区分コード =
          荷主請求Res.data.高速料税込区分コード
        castedData.請求高速料税込区分名称1 =
          荷主請求Res.data.高速料税込区分名称1
        castedData.支払高速料税込区分コード =
          荷主請求Res.data.高速料税込区分コード
      }
    } catch (error) {}
  } else {
    castedData.請求高速料税込区分コード = ""
    castedData.請求高速料税込区分名称1 = ""
  }

  castedData.請求高速料 = パターン.請求高速料

  if (set車輌情報) {
    switch (castedData.請求車輌区分コード) {
      case e請求車輌区分.ヘッド:
        castedData.請求車番 = パターン.車番
        break
      case e請求車輌区分.トレーラー:
        castedData.請求車番 = パターン.トレーラ車番
        break
      default:
        break
    }
  }
  // パターンの計上基準日区分が空のとき荷主請求内訳IDで検索して取得しなおす
  if (
    パターン.計上基準日区分コード != null &&
    パターン.計上基準日区分コード !== ""
  ) {
    castedData.計上基準日区分コード = パターン.計上基準日区分コード
    castedData.計上基準日区分名称1 = パターン.計上基準日区分名称1
  } else if (パターン.荷主請求内訳ID != null) {
    try {
      const 請求内訳res = await new NinusiSeikyuService().getListUchiwake({
        荷主請求内訳Id: パターン.荷主請求内訳ID,
      })
      if (請求内訳res && 請求内訳res.data.length > 0) {
        castedData.計上基準日区分コード =
          請求内訳res.data[0].計上基準日区分コード
        castedData.計上基準日区分名称1 = 請求内訳res.data[0].計上基準日区分名称1

        // 計上基準日区分で請求計上日を設定する
        switch (castedData.計上基準日区分コード as T計上基準日区分) {
          case e計上基準日区分.積日:
            castedData.請求計上日 = castedData.積日
            break
          case e計上基準日区分.卸日:
            castedData.請求計上日 = castedData.卸日
            break
          default:
            break
        }
      }
    } catch (error) {}
  }

  // 計上基準日区分で請求計上日を設定する
  switch (castedData.計上基準日区分コード as T計上基準日区分) {
    case e計上基準日区分.積日:
      castedData.請求計上日 = castedData.積日
      break
    case e計上基準日区分.卸日:
      castedData.請求計上日 = castedData.卸日
      break
    default:
      break
  }

  castedData.請求備考 = パターン.請求備考
  castedData.支払運送料課税区分コード = パターン.支払運送料課税区分コード
  castedData.支払運送料 = パターン.支払運送料
  castedData.支払付帯料課税区分コード = パターン.支払付帯料課税区分コード
  castedData.支払付帯料 = パターン.支払付帯料
  castedData.支払高速料 = パターン.支払高速料
  castedData.支払備考 = パターン.支払備考
  // 支払計上日を傭車会社の存在有無で設定を行う
  if (castedData.支払先ID) {
    castedData.支払計上日 = castedData.卸日
  }
}

/**
 * 現在の配車状態区分と車輌IDの存在より配車状態区分を返還する関数
 */
export const set配車状態区分By車輌ID = (
  配車状態区分コード: string | null | undefined,
  車輌ID: number | undefined | null
) => {
  // 配車状態区分が空もしくは未配車かつ車輌が登録されていた場合、自動的に配車確定に変更
  // 車輌が設定されておらず、配車確定または未選択の場合、未配車に変更する。
  let return配車状態区分コード = 配車状態区分コード
  if (
    return配車状態区分コード == null ||
    return配車状態区分コード === "" ||
    return配車状態区分コード === e配車状態区分.未配車
  ) {
    if (車輌ID != null) {
      return配車状態区分コード = e配車状態区分.配車確定
    } else {
      return配車状態区分コード =
        return配車状態区分コード ?? e配車状態区分.未配車
    }
  } else if (
    return配車状態区分コード == null ||
    return配車状態区分コード === "" ||
    return配車状態区分コード === e配車状態区分.配車確定
  ) {
    if (車輌ID == null) {
      return配車状態区分コード = e配車状態区分.未配車
    } else {
      return配車状態区分コード =
        return配車状態区分コード ?? e配車状態区分.配車確定
    }
  }
  return return配車状態区分コード
}

/**
 * 車輌の情報をキャストします
 */
export const castヘッド車輌 = <TItem extends TZyutyuHaisyaListGetRes>(
  rowItem: TItem,
  車輌: TSyaryoModalList | null | undefined
) => {
  if (車輌) {
    rowItem.車輌ID = 車輌.車輌ID
    rowItem.車番 = 車輌.車番
    rowItem.車種区分コード = 車輌.車種区分コード
    rowItem.車種区分名称1 = 車輌.車種区分名称1
    rowItem.最大積載量 = 車輌.最大積載量
    rowItem.稼働手当車種掛率区分コード = 車輌.稼働手当車種別掛率区分コード

    // 請求車輌がヘッドであれば請求車番に車番を入力
    if (rowItem.請求車輌区分コード === e請求車輌区分.ヘッド) {
      rowItem.請求車番 = 車輌.車番
    }
    if (車輌.トレーラ車輌ID != null) {
      rowItem.トレーラ車輌ID = 車輌.トレーラ車輌ID
      rowItem.トレーラ車番 = 車輌.トレーラ車番
      rowItem.トレーラ車種区分コード = 車輌.トレーラ車種区分コード
      rowItem.トレーラ車種区分名称1 = 車輌.トレーラ車種区分名称1
      rowItem.トレーラ車種最大積載量 = 車輌.トレーラ最大積載量
      // 請求車輌がトレーラであれば請求車番にトレーラ車番を入力
      if (rowItem.請求車輌区分コード === e請求車輌区分.トレーラー) {
        rowItem.請求車番 = 車輌.トレーラ車番
      }
    }

    if (車輌.社員ID != null) {
      rowItem.乗務員ID = 車輌.社員ID
      rowItem.乗務員コード = 車輌.社員コード
      rowItem.乗務員名 = 車輌.社員氏名
    }
  } else {
    // データは削除する
    rowItem.車輌ID = undefined
    rowItem.車番 = undefined
    rowItem.車種区分コード = undefined
    rowItem.車種区分名称1 = undefined
    rowItem.最大積載量 = undefined
    if (rowItem.請求車輌区分コード === e請求車輌区分.ヘッド) {
      rowItem.請求車番 = undefined
    }
  }
}

/**
 * 車輌の情報をキャストします
 */
export const castヘッド車輌By傭車 = <TItem extends TZyutyuHaisyaListGetRes>(
  rowItem: TItem,
  傭車: T傭車マスタ | null | undefined
) => {
  if (傭車) {
    rowItem.車輌ID = undefined
    rowItem.車番 = 傭車.車番
    rowItem.車種区分コード = 傭車.車種区分コード
    rowItem.車種区分名称1 = 傭車.車種区分名称1
    rowItem.最大積載量 = undefined
    rowItem.稼働手当車種掛率区分コード = undefined

    // 請求車輌がヘッドであれば請求車番に車番を入力
    if (rowItem.請求車輌区分コード === e請求車輌区分.ヘッド) {
      rowItem.請求車番 = 傭車.車番
    }
    // ヘッド修正時にトレーラは特に操作しない
    rowItem.乗務員ID = undefined
    rowItem.乗務員コード = undefined
    rowItem.乗務員名 = 傭車.乗務員名
  } else {
    // データは削除する
    rowItem.車輌ID = undefined
    rowItem.車番 = undefined
    rowItem.車種区分コード = undefined
    rowItem.車種区分名称1 = undefined
    rowItem.最大積載量 = undefined
    if (rowItem.請求車輌区分コード === e請求車輌区分.ヘッド) {
      rowItem.請求車番 = rowItem.車番
    }
  }
}

/**
 * トレーラ車輌の情報をキャストします
 */
export const castトレーラ車輌 = <TItem extends TZyutyuHaisyaListGetRes>(
  rowItem: TItem,
  車輌: TSyaryoModalList | null | undefined
) => {
  if (車輌) {
    rowItem.トレーラ車輌ID = 車輌.車輌ID
    rowItem.トレーラ車番 = 車輌.車番
    rowItem.トレーラ車種区分コード = 車輌.車種区分コード
    rowItem.トレーラ車種区分名称1 = 車輌.車種区分名称1
    rowItem.トレーラ車種最大積載量 = 車輌.最大積載量
    // 新規で請求車輌がトレーラであれば請求車番に車番を入力
    if (rowItem.請求車輌区分コード === e請求車輌区分.トレーラー) {
      rowItem.請求車番 = 車輌.車番
    }
  } else {
    // データは削除する
    // 車番は自由入力のため、そのままとする
    rowItem.トレーラ車輌ID = undefined
    rowItem.トレーラ車番 = undefined
    rowItem.トレーラ車種区分コード = undefined
    rowItem.トレーラ車種区分名称1 = undefined
    rowItem.トレーラ車種最大積載量 = undefined
    if (rowItem.請求車輌区分コード === e請求車輌区分.トレーラー) {
      rowItem.請求車番 = undefined
    }
  }
}

/**
 * トレーラ車輌の情報をキャストします
 */
export const castトレーラ車輌By傭車 = <TItem extends TZyutyuHaisyaListGetRes>(
  rowItem: TItem,
  傭車: T傭車マスタ | null | undefined
) => {
  // 選択された場合は必ずトレーラ車輛IDは消去する
  rowItem.トレーラ車輌ID = undefined

  if (傭車) {
    rowItem.トレーラ車輌ID = undefined
    rowItem.トレーラ車番 = 傭車.車番
    rowItem.トレーラ車種区分コード = 傭車.車種区分コード
    rowItem.トレーラ車種区分名称1 = 傭車.車種区分名称1
    rowItem.トレーラ車種最大積載量 = undefined
    // 新規で請求車輌がトレーラであれば請求車番に車番を入力
    if (rowItem.請求車輌区分コード === e請求車輌区分.トレーラー) {
      rowItem.請求車番 = 傭車.車番
    }
  } else {
    // データは削除する
    rowItem.トレーラ車輌ID = undefined
    rowItem.トレーラ車番 = undefined
    rowItem.トレーラ車種区分コード = undefined
    rowItem.トレーラ車種区分名称1 = undefined
    rowItem.トレーラ車種最大積載量 = undefined
    if (rowItem.請求車輌区分コード === e請求車輌区分.トレーラー) {
      rowItem.請求車番 = rowItem.トレーラ車番
    }
  }
}

/**
 * 積卸先の情報をキャストします
 */
export const cast積卸先 = <
  TItem extends TZyutyuHaisyaListGetRes & T手入力チェック
>(
  rowItem: TItem,
  積卸先: TTumiorosisakiListGetRes | null | undefined,
  積卸: "積" | "卸"
) => {
  if (積卸 === "積") {
    if (積卸先 == null) {
      rowItem.積地積卸先ID = undefined
      rowItem.積地積卸先コード = undefined
      rowItem.積地社名 = undefined
      rowItem.積地都道府県 = undefined
      rowItem.積地市区町村 = undefined
    } else {
      rowItem.積地積卸先ID = 積卸先.積卸先ID
      rowItem.積地積卸先コード = 積卸先.積卸先コード
      rowItem.積地社名 = 積卸先.積卸先略称
      rowItem.積地都道府県 = 積卸先.住所１
      rowItem.積地市区町村 = 積卸先.住所２
      rowItem.is積地手編集 = false
    }
  } else {
    if (積卸先 == null) {
      rowItem.卸地積卸先ID = undefined
      rowItem.卸地積卸先コード = undefined
      rowItem.卸地社名 = undefined
      rowItem.卸地都道府県 = undefined
      rowItem.卸地市区町村 = undefined
    } else {
      rowItem.卸地積卸先ID = 積卸先.積卸先ID
      rowItem.卸地積卸先コード = 積卸先.積卸先コード
      rowItem.卸地社名 = 積卸先.積卸先略称
      rowItem.卸地都道府県 = 積卸先.住所１
      rowItem.卸地市区町村 = 積卸先.住所２
      rowItem.is卸地手編集 = false
    }
  }
}

/**
 * 品名の情報をキャストします
 */
export const cast品名 = <
  TItem extends TZyutyuHaisyaListGetRes & T手入力チェック
>(
  rowItem: TItem,
  品名: T品名マスタ | null | undefined
) => {
  if (rowItem.品コード !== CONSTANT.自由入力品コード) {
    if (品名 == null) {
      rowItem.荷主品名ID = undefined
      rowItem.品コード = undefined
      rowItem.品名 = undefined
      rowItem.単位区分コード = undefined
    } else {
      rowItem.荷主品名ID = 品名.荷主品名ID
      rowItem.品コード = 品名.品コード
      rowItem.品名 = 品名.品名
      rowItem.単位区分コード = 品名.単位区分コード
      if (rowItem.荷主コード) {
        rowItem.荷主請求内訳ID = 品名.荷主請求内訳ID
      }
      rowItem.is品名手編集 = false
    }
  } else {
    // 自由入力の場合コードのみ消す
    rowItem.荷主品名ID = undefined
  }
}

/**
 * 乗務員の情報をキャストします
 */
export const cast乗務員 = <TItem extends TZyutyuHaisyaListGetRes>(
  rowItem: TItem,
  乗務員: TZyomuinListItem | null | undefined,
  乗務員種別: "乗務員" | "同乗者"
) => {
  if (乗務員 != null) {
    if (乗務員種別 === "乗務員") {
      rowItem.乗務員コード = 乗務員.社員コード
      rowItem.乗務員名 = 乗務員.社員氏名
      rowItem.乗務員ID = 乗務員.乗務員ID
    } else {
      rowItem.同乗者コード = 乗務員.社員コード
      rowItem.同乗者名 = 乗務員.社員氏名
      rowItem.同乗者乗務員ID = 乗務員.乗務員ID
    }
  } else {
    if (乗務員種別 === "乗務員") {
      rowItem.乗務員コード = ""
      rowItem.乗務員名 = ""
      rowItem.乗務員ID = undefined
    } else {
      rowItem.同乗者コード = ""
      rowItem.同乗者名 = ""
      rowItem.同乗者乗務員ID = undefined
    }
  }
}

/**
 * 傭車設定時に不要な情報を削除します
 * @param casted
 */
export const clear運行情報At傭車設定時 = <
  TItem extends TZyutyuHaisyaListGetRes
>(
  casted: TItem
) => {
  // ヘッド車輌
  casted.車輌ID = undefined
  casted.車番 = undefined
  casted.車種区分コード = undefined
  casted.車種区分ソート番号 = undefined
  casted.車種区分名称1 = undefined
  casted.最大積載量 = undefined
  casted.稼働手当車種掛率区分ID = undefined
  casted.稼働手当車種掛率区分コード = undefined
  casted.稼働手当車種掛率区分ソート番号 = undefined
  casted.稼働手当車種掛率区分名称1 = undefined
  casted.稼働手当車種掛率区分少数値1 = undefined
  // トレーラ車輌
  casted.トレーラ車輌ID = undefined
  casted.トレーラ車番 = undefined
  casted.トレーラ車種区分コード = undefined
  casted.トレーラ車種区分ソート番号 = undefined
  casted.トレーラ車種区分名称1 = undefined
  casted.トレーラ車種最大積載量 = undefined
  // 乗務員
  casted.乗務員ID = undefined
  casted.乗務員コード = undefined
  casted.乗務員名 = undefined
  // 同乗者
  casted.同乗者乗務員ID = undefined
  casted.同乗者コード = undefined
  casted.同乗者名 = undefined
  casted.同乗者場所区分ID = undefined
  casted.同乗者場所区分コード = undefined
  casted.同乗者場所区分ソート番号 = undefined
  casted.同乗者場所区分名称1 = undefined
  // 手当系
  casted.食事手当 = undefined
  casted.特別手当 = undefined
  casted.稼働手当 = undefined
}

/**
 * 請求確認済であるかを確認します
 * @param dataItem
 * @returns
 */
export const is請求確認済 = <T extends Partial<TZyutyuHaisyaListGetRes>>(
  dataItem: T
) =>
  dataItem.請求額確認区分コード === e請求支払確認区分.確認済 ||
  dataItem.請求処理状態区分コード === e請求支払処理状態区分.確定 ||
  dataItem.請求処理状態区分コード === e請求支払処理状態区分.送付済

/**
 * 数量単価および数量修正時の自動計算関数
 * @param dataItem
 */
export const 積載品入力時運送料自動計算 = <
  T extends TZyutyuHaisyaListGetRes & T手入力チェック
>(
  dataItem: T
) => {
  // 請求区分が品数毎のときだけ積載品数量と単価から運送料を計算する
  if (dataItem.請求区分コード === e請求支払区分.品数毎) {
    Decimal.set({
      rounding: Decimal.ROUND_HALF_CEIL,
    })
    // 数量がクリアされた場合は品数に関わらず運送料をリセット
    if (dataItem.積載品数量 == null) {
      dataItem.請求運送料 = undefined
      if (!dataItem?.is乗務員売上手編集) {
        dataItem.乗務員売上額 = undefined
      }
      dataItem.同乗者売上額 = undefined
      return
    }
    // 2品以上は計算しない
    if (dataItem.品数 != null && dataItem.品数 > 2) return

    // 請求運送料計算を行う
    dataItem.請求運送料 = 請求運送料計算(
      dataItem.単価,
      dataItem.積載品数量,
      dataItem
    )

    // 手入力フラグがONの場合は売上と連動させない
    if (dataItem?.is乗務員売上手編集) return

    dataItem.乗務員売上額 = dataItem.請求運送料

    if (
      dataItem.同乗者乗務員ID != null ||
      (dataItem.同乗者名 != null && dataItem.同乗者名 !== "")
    ) {
      dataItem.同乗者売上額 = set同乗者売上(dataItem)
    }
  }
}

/**
 * 請求運送料を計算する
 * 特殊計算はここで行う
 * @param dataItem
 * @returns
 */
export const 請求運送料計算: <
  T extends {
    荷主コード?: string
    表紙分割コード?: string
    品コード?: string
    品代端数計算区分コード?: string | null
    受注配車パターンコード?: string
    請求内訳コード?: string
  }
>(
  単価: number | undefined | null,
  積載品数量: number | undefined | null,
  dataItem?: T
) => number = (単価, 積載品数量, dataItem) => {
  const inner積載品数量 = 積載品数量 ?? 0
  const inner単価 = 単価 ?? 0

  if (dataItem) {
    let 請求運送料: Decimal = new Decimal(inner単価).times(inner積載品数量)

    // 荷主CD：62040　備北粉化工業
    // 表紙CD：１　運送料
    if (
      dataItem.荷主コード &&
      dataItem.荷主コード === CONSTANT.備北粉化工業_荷主コード &&
      dataItem.表紙分割コード &&
      dataItem.表紙分割コード === CONSTANT.備北粉化工業_運送料_表紙分割コード
    ) {
      switch (dataItem.品コード) {
        case CONSTANT.備北粉化工業_H90HS_品コード:
          // 品名CD：14120　品名：H90HSの場合
          // 数量（ｔ）×0.78（小数点第四位切り捨て）×単価（3,800円）
          請求運送料 = new Decimal(inner積載品数量)
            .times(1000)
            .times(CONSTANT.備北粉化工業_H90HS_掛率)
            .trunc()
            .dividedBy(1000)
            .times(inner単価)
          break
        case CONSTANT.備北粉化工業_S97_品コード:
          // 品名CD：14430　品名：S97の場合
          // 数量（ｔ）×0.75（小数点第四位切り捨て）×単価（3,800円）
          請求運送料 = new Decimal(inner積載品数量)
            .times(1000)
            .times(CONSTANT.備北粉化工業_S97_掛率)
            .trunc()
            .dividedBy(1000)
            .times(inner単価)
          break
        default:
          break
      }
    } else if (
      // 昭和産業トン数保障組合わせ
      dataItem.荷主コード &&
      dataItem.荷主コード === CONSTANT.unsoryoHosyo.昭和産業.荷主コード
    ) {
      // 表紙コードが違えば保障対象外
      switch (dataItem.表紙分割コード) { // 表紙コードで分岐(表紙分割コード = 表紙コード)
        //ジャーム / ジャームダンプ の場合 (表紙CD=1)
        case CONSTANT.unsoryoHosyo.昭和産業.表紙.ジャーム.コード:
          if (
            dataItem.請求内訳コード ===
            CONSTANT.unsoryoHosyo.昭和産業.表紙.ジャーム.請求内訳コード
          ) {
            // ジャーム: 10tまで補償
            if (
              CONSTANT.unsoryoHosyo.昭和産業.表紙.ジャーム.保障数量 <=
              inner積載品数量
            )
              break

            請求運送料 = new Decimal(
              CONSTANT.unsoryoHosyo.昭和産業.表紙.ジャーム.保障金額
            )
          } else if (
            dataItem.請求内訳コード ===
            CONSTANT.unsoryoHosyo.昭和産業.表紙.ジャームダンプ.請求内訳コード
          ) {
            // ジャームダンプ: 10tまで補償
            if (
              CONSTANT.unsoryoHosyo.昭和産業.表紙.ジャームダンプ.保障数量 <=
              inner積載品数量
            )
              break

            請求運送料 = new Decimal(
              CONSTANT.unsoryoHosyo.昭和産業.表紙.ジャームダンプ.保障金額
            )
          }
          break
        //ジャーム粕の場合 (表紙CD=2)
        case CONSTANT.unsoryoHosyo.昭和産業.表紙.ジャーム粕.コード:
          if (
            dataItem.請求内訳コード ===
            CONSTANT.unsoryoHosyo.昭和産業.表紙.ジャーム粕.請求内訳コード
          ) {
            // ジャーム粕: 8tまで補償
            if (
              CONSTANT.unsoryoHosyo.昭和産業.表紙.ジャーム粕.保障数量 <=
              inner積載品数量
            )
              break

            請求運送料 = new Decimal(
              CONSTANT.unsoryoHosyo.昭和産業.表紙.ジャーム粕.保障金額
            )
          }
          break
        default:
          break
      }
    }

    switch (dataItem.品代端数計算区分コード as T消費税計算区分) {
      case e消費税計算区分.切り捨て:
        return 請求運送料.floor().toNumber()
      case e消費税計算区分.切り上げ:
        return 請求運送料.ceil().toNumber()
      case e消費税計算区分.四捨五入:
      default:
        // 積載品数量 * 単価の四捨五入を請求運送料とする
        return 請求運送料.round().toNumber()
    }
  }
  // 積載品数量 * 単価の四捨五入を請求運送料とする
  return new Decimal(inner単価)
    .times(inner積載品数量 ?? 0)
    .round()
    .toNumber()
}

/**
 * 同乗者売上自動計算用
 * @param dataItem
 */
export const set同乗者売上 = <
  T extends { 同乗者乗務員ID?: number; 乗務員売上額?: number }
>(
  dataItem: T
) => {
  // 同乗者が既に設定されていない場合は0返却
  if (dataItem.同乗者乗務員ID == null) {
    return 0
  }
  // 小数点以下は切り捨て
  return 同乗者売上計算(dataItem.乗務員売上額)
}

/**
 * 同乗者売り上げ計算
 * @param 乗務員売上額
 * @returns
 */
export const 同乗者売上計算 = (乗務員売上額: number | undefined) => {
  return new Decimal(乗務員売上額 ?? 0).times(0.5).truncated().toNumber()
}
/**
 * SYプロモーションで付帯料が付与される条件であるかを確認するメソッドです
 * 荷主コードと、卸先コード、車番、乗務員コードが一致するとき
 * 請求付帯料は10000で固定となる。また、乗務員付帯料に請求付帯料が連動しなくなります
 * @param dataItem
 * @returns
 */
export const SYプロモーション特殊条件合致チェック: <
  T extends Partial<
    TZyutyuHaisyaListGetRes & {
      積卸情報?: { 工程区分コード?: string; 積卸先コード?: string }[]
    }
  >
>(
  dataItem: T
) => boolean = (dataItem) => {
  if (dataItem.荷主コード !== constants.SYプロモーション特殊条件.荷主コード)
    return false
  if (dataItem.車番 !== constants.SYプロモーション特殊条件.車番) return false
  if (
    dataItem.乗務員コード == null ||
    !constants.SYプロモーション特殊条件.乗務員コード.includes(
      dataItem.乗務員コード
    )
  )
    return false

  // 卸先に一致する積卸先コードが存在するときのみtrue
  if (
    dataItem.卸地積卸先コード != null &&
    dataItem.卸地積卸先コード !== "" &&
    dataItem.卸地積卸先コード === constants.SYプロモーション特殊条件.卸先コード
  ) {
    return true
  } else if (dataItem.積卸情報) {
    return (
      dataItem.積卸情報.find(
        (積卸) =>
          積卸.工程区分コード === e工程区分.卸 &&
          積卸.積卸先コード === constants.SYプロモーション特殊条件.卸先コード
      ) != null
    )
  }

  return false
}

/**
 * 乗務員フォーカスアウト時の動き
 */
export const get乗務員 = async (乗務員コード: string) => {
  try {
    const res = await new ZyomuinService().getList({
      社員コード: 乗務員コード,
      社員コード完全一致フラグ: true,
    })
    if (res && res.data.length === 1) {
      return res.data[0]
    }
  } catch (error) {
    throw error
  }
  return
}

//#region [共通化Handler]

/**
 * 傭車オートフォーカス検索処理
 * @param 傭車コードRef
 * @returns
 */
export const getYosyaItemsSource: (
  傭車コードRef: React.MutableRefObject<string | undefined>
) => wjcInput.IGetItems =
  (傭車コードRef: React.MutableRefObject<string | undefined>) =>
  async (query: string, max: number, callback: wjcInput.IGetItemsCallback) => {
    const 傭車コード = 傭車コードRef.current ?? ""

    if (傭車コード === "") {
      callback([])
      return
    }
    get傭車itemsSourceFunctionByApi(query, max, callback, 傭車コード)
  }

/**
 * 車輌オートフォーカス検索処理
 * @param 運行部所コードRef
 * @param 原動機有無フラグ
 * @returns
 */
export const getSyaryoItemsSource: (
  運行部所コードRef: React.MutableRefObject<string | undefined>,
  v: 0 | 1
) => wjcInput.IGetItems =
  (
    運行部所コードRef: React.MutableRefObject<string | undefined>,
    原動機有無フラグ: 0 | 1
  ) =>
  async (query: string, max: number, callback: wjcInput.IGetItemsCallback) => {
    const 部所コード = 運行部所コードRef.current ?? ""
    if (!全部所車番検索Enabled && 部所コード === "") {
      callback([])
      return
    }
    get車輌itemsSourceFunctionByApi(
      query,
      max,
      callback,
      原動機有無フラグ,
      全部所車番検索Enabled ? undefined : 部所コード
    )
  }

export const 受領書DataMap = new wjcGrid.DataMap(
  [
    { key: "無", value: 0 },
    { key: "有", value: 1 },
  ],
  "value",
  "key"
)

//#endregion

//#region excelおよびpdfフォーマット用

// 時間系カラム一覧
export const 時間columns: (keyof TZyutyuHaisyaListGetRes)[] = [
  "積日",
  "卸日",
  "請求計上日",
  "支払計上日",
]
export const 海コン時間columns: (keyof TKaikonZyutyuHaisyaListGetRes)[] = [
  "PICK作業日",
  "作業作業日",
  "返却作業日",
  "その他作業日",
  "請求計上日",
  "支払計上日",
]
// MEMO:点検整備関係
const 点検整備columns: (keyof TTenkenSeibiListGetRes)[] = [
  "車検満了日",
  "廃車予定年月",
]
const 点検整備費columns: (keyof TTenkenSeibihiListGetRes)[] = [
  "点検整備予定日",
  "点検整備実施日",
]
// MEMO:有休管理
const 有休管理columns: (keyof TVacationGetRes)[] = ["入社年月日", "最新付与日"]

// MEMO:乗務員マスタ一覧
const 乗務員マスタ一覧columns: (keyof TZyomuinListItem)[] = [
  "入社年月日",
  "免許更新日",
  "有効期限",
]

export const abstractPdfFormat: (
  columns: string[]
) => (args: wjcGridPdf.PdfFormatItemEventArgs) => void =
  (columns: string[]) => (args) => {
    const p = args.panel
    const col = args.col
    const binding: keyof TZyutyuHaisyaListGetRes = p.columns[col]
      .binding as keyof TZyutyuHaisyaListGetRes
    // 時間のセルは存在しないため時間系のカラムは一括返還する
    if (p.cellType === wjcGrid.CellType.Cell) {
      if (binding && columns.includes(binding)) {
        if (args.data && dayjs(args.data).isValid()) {
          const value = args.data
          args.data = dayjs(value).format("YYYY/MM/DD")
        }
      }
    }
  }

export const abstractExcelFormat: (
  columns: string[]
) => (args: wjcGridXlsx.XlsxFormatItemEventArgs) => void =
  (columns: string[]) => (args) => {
    const p = args.panel
    const col = args.col
    const xlsxCell = args.xlsxCell
    const binding: keyof TZyutyuHaisyaListGetRes = p.columns[col]
      .binding as keyof TZyutyuHaisyaListGetRes
    // 時間のセルは存在しないため時間系のカラムは一括返還する
    if (p.cellType === wjcGrid.CellType.Cell) {
      if (binding && columns.includes(binding)) {
        if (xlsxCell.value && dayjs(xlsxCell.value).isValid()) {
          const value = xlsxCell.value
          xlsxCell.value = dayjs(value).format("YYYY/MM/DD")
        }
      }
    }
  }

// export const excelFormat: (
//   args: wjcGridXlsx.XlsxFormatItemEventArgs
// ) => void = (args) => {
//   const p = args.panel
//   const col = args.col
//   const xlsxCell = args.xlsxCell
//   const binding: keyof TZyutyuHaisyaListGetRes = p.columns[col]
//     .binding as keyof TZyutyuHaisyaListGetRes
//   // 時間のセルは存在しないため時間系のカラムは一括返還する
//   if (p.cellType === wjcGrid.CellType.Cell) {
//     if (binding && 時間columns.includes(binding)) {
//       if (xlsxCell.value && dayjs(xlsxCell.value).isValid()) {
//         const value = xlsxCell.value
//         xlsxCell.value = dayjs(value).format("YYYY/MM/DD")
//       }
//     }
//   }
// }

export const pdfFormat = abstractPdfFormat(時間columns)
export const excelFormat = abstractExcelFormat(時間columns)
export const kaikonExcelFormat = abstractExcelFormat(海コン時間columns)
// MEMO:点検整備関係
export const tenkenseibiPdfFormat = abstractPdfFormat(点検整備columns)
export const tenkenseibihiPdfFormat = abstractPdfFormat(点検整備費columns)
export const tenkenseibiExcelFormat = abstractExcelFormat(点検整備columns)
export const tenkenseibihiExcelFormat = abstractExcelFormat(点検整備費columns)
// MEMO:有休管理
export const vacationExcelFormat = abstractExcelFormat(有休管理columns)
export const vacationPdfFormat = abstractPdfFormat(有休管理columns)

// MEMO:乗務員マスタ一覧
export const zyomuinMasterListExcelFormat =
  abstractExcelFormat(乗務員マスタ一覧columns)
export const zyomuinMasterListPdfFormat =
  abstractPdfFormat(乗務員マスタ一覧columns)
//#endregion
